const th = {
    // ─── Navbar ───
    nav: {
        home: 'หน้าแรก',
        games: 'บริการเกม',
        marketplace: 'ตลาดซื้อ-ขาย',
        portfolio: 'ผลงาน',
        news: 'ข่าวสาร',
        live: 'ไลฟ์สด',
        dashboard: 'แดชบอร์ด',
        history: 'ประวัติ',
        orderHistory: 'ประวัติสั่งซื้อ',
        login: 'เข้าสู่ระบบ',
        register: 'สมัครสมาชิก',
        loginOrRegister: 'เข้าสู่ระบบ / สมัครสมาชิก',
        loginToStart: 'เข้าสู่ระบบเพื่อเริ่มใช้งาน',
        logout: 'ออกจากระบบ',
        jobs: 'จ้างงาน',
    },

    // ─── Hero Section ───
    hero: {
        badge: '#1 Gaming Marketplace in SEA',
        titleLine1: 'ยกระดับการเล่นเกมของคุณ',
        titleLine2: 'ด้วยทีมงานมืออาชีพที่',
        titleBrand: 'Fastlane Lv.',
        subtitleLine1: 'ซื้อ-ขาย ไอเทมระดับเทพ บริการปั้นเลเวล และไอดีเกมคุณภาพเยี่ยม',
        subtitleLine2: 'ด้วยทีมงานมืออาชีพที่มีประสบการณ์มากกว่า 30 ปี',
        searchPlaceholder: 'ค้นหาชื่อเกม, ไอเทม, หรือบริการที่ต้องการ...',
        searchButton: 'ค้นหาเลย',
        trustBadge1: 'รับประกันคืนเงิน',
        trustBadge2: 'ส่งงานรวดเร็ว',
        trustBadge3: 'ทีมงานมืออาชีพ',
        sponsorLabel: 'ผู้สนับสนุนอย่างเป็นทางการ',
        sponsorsLabel: 'ผู้สนับสนุนอย่างเป็นทางการ',
        sponsorTagline: 'แบรนด์ที่ไว้วางใจ และร่วมเดินทางไปกับ Fastlane Lv.',
        sponsorVisit: 'เยี่ยมชมร้าน',
        sponsorLogoAlt: 'โลโก้ผู้สนับสนุน',
    },

    // ─── Home Page ───
    home: {
        recommended: 'รายการแนะนำล่าสุด',
        marketplace: 'ตลาดซื้อขาย',
        services: 'บริการเกมแนะนำ',
        servicesDesc: 'ครอบคลุมทุกความต้องการจากเหล่านักเล่นเกมมืออาชีพ',
        viewAll: 'ดูรายการทั้งหมด',
        viewAllShort: 'ดูทั้งหมด',
        viewDetails: 'ดูรายละเอียด',
        startingPrice: 'ราคาเริ่มต้น',
        price: 'ราคา',
        gameAccount: 'ไอดีเกม',
        gameItem: 'ไอเทม',
        chooseService: 'เลือกบริการที่ใช่สำหรับคุณ',
    },

    // ─── Stats Section ───
    stats: {
        whyChoose: 'ทำไมต้องเลือก',
        trustedPlatform: 'แพลตฟอร์มที่ผู้เล่นไว้วางใจ',
        totalMembers: 'สมาชิกทั้งหมด',
        realUsers: 'ผู้ใช้งานจริง',
        completedOrders: 'ออเดอร์สำเร็จ',
        successfulTx: 'ธุรกรรมสำเร็จ',
        supportedGames: 'เกมที่รองรับ',
        popularGames: 'เกมยอดฮิต',
        satisfaction: 'ระดับความพึงพอใจ',
        fromRealReviews: 'จากรีวิวจริง',
    },

    // ─── Reviews Section ───
    reviews: {
        badge: '⭐ รีวิวจากผู้ใช้จริง',
        title: 'เสียงจากลูกค้า',
        subtitle: '{count} รีวิว จากผู้ใช้งานจริงทั่วประเทศ',
        fromReviews: 'จาก {count} รีวิว',
        dateLocale: 'th-TH',
    },

    // ─── Footer ───
    footer: {
        desc1: 'แพลตฟอร์มซื้อขายไอเทมเกม',
        desc2: 'และบริการเกมครบวงจร',
        desc3: 'ปลอดภัย รวดเร็ว มั่นใจ',
        allGames: 'เกมทั้งหมด',
        gameAccounts: 'ไอดีเกม',
        itemsAndSkins: 'ไอเทม & สกิน',
        boostingService: 'บริการรับจ้างเล่น',
        marketplaceTitle: 'ตลาดซื้อขาย',
        communityTitle: 'ชุมชน',
        contactUs: 'ติดต่อเรา',
        faq: 'คำถามที่พบบ่อย',
        available247: 'เปิดให้บริการ 24/7',
        serverStatus: 'Server Status: Online',
        allRightsReserved: '© 2025 FASTLANE LV Co., Ltd.',
    },

    // ─── Games Page ───
    gamesPage: {
        title: 'บริการเกมทั้งหมด',
        subtitle: 'เลือกเกมที่คุณต้องการ',
        search: 'ค้นหาเกม...',
        allGames: 'เกมทั้งหมด',
        noResults: 'ไม่พบเกมที่ค้นหา',
        badge: 'บริการเกม',
        heroTitle1: 'บริการเกม',
        heroTitle2: 'ทั้งหมด',
        heroDesc: 'เลือกเกมที่คุณต้องการ แล้วเราจะดูแลให้คุณ ครอบคลุมทุกเกมยอดฮิต',
        searchPlaceholder: 'ค้นหาชื่อเกม...',
        trustGuarantee: 'รับประกันคืนเงิน',
        trustFast: 'ส่งงานรวดเร็ว',
        trustVerified: 'ทีมงานมืออาชีพ',
        searchResults: 'ผลการค้นหา',
        gamesCount: 'เกม',
        matchSearch: 'ที่ตรงกับการค้นหา',
        viewService: 'ดูบริการ',
        showMore: 'แสดงมากกว่านี้',
        remaining: 'เกมที่เหลือ',
        noGames: 'ไม่พบเกม',
        noGamesFor: 'ไม่มีเกมที่ตรงกับ',
        clearSearch: 'ล้างการค้นหา',
    },

    // ─── Marketplace ───
    marketplacePage: {
        title: 'ตลาดซื้อ-ขาย',
        subtitle: 'ซื้อขายไอเทม ไอดีเกม และบริการต่างๆ',
        filter: 'ตัวกรอง',
        allTypes: 'ทั้งหมด',
        account: 'ไอดีเกม',
        item: 'ไอเทม',
        search: 'ค้นหาสินค้า...',
        noItems: 'ไม่พบรายการ',
        available: 'ว่าง',
        sold: 'ขายแล้ว',
        reserved: 'จองแล้ว',
        contactSeller: 'ติดต่อผู้ขาย',
        // Detail page
        price: 'ราคา',
        description: 'คำอธิบาย',
        details: 'รายละเอียด',
        game: 'เกม',
        type: 'ประเภท',
        status: 'สถานะ',
        listedDate: 'วันที่ลงขาย',
        shareTo: 'แชร์ไปยัง',
        copyLink: 'คัดลอกลิงก์',
        copied: 'คัดลอกแล้ว!',
        contactLine: 'ติดต่อซื้อสินค้า',
        proposePrice: 'เสนอราคา',
        loginToBuy: 'เข้าสู่ระบบเพื่อติดต่อซื้อ',
        trustSafe: 'ปลอดภัย 100%',
        trustInsured: 'มีประกัน',
        trustSupport: 'ซัพพอร์ต 24/7',
        verifiedTitle: 'ตรวจสอบแล้ว',
        verifiedDesc: 'สินค้าทุกชิ้นผ่านการตรวจสอบและรับรองจากทีมงาน Fastlane Lv.',
        deliveryTitle: 'จัดส่งทันที',
        deliveryDesc: 'ส่งข้อมูลสินค้าทันที หลังชำระเงิน ไม่ต้องรอนาน',
        warrantyTitle: 'รับประกัน',
        warrantyDesc: 'มีการรับประกันสินค้าทุกชิ้น หากพบปัญหาสามารถติดต่อทีมซัพพอร์ตได้ตลอด 24 ชม.',
        noItemFound: 'ไม่พบสินค้า',
        noItemFoundDesc: 'สินค้านี้อาจถูกลบออกหรือไม่มีอยู่ในระบบ',
        backToMarketplace: 'กลับไปหน้าตลาดซื้อขาย',
        relatedItems: 'สินค้าที่คุณอาจสนใจ',
        marketplace: 'ตลาดซื้อขาย',
        // Sidebar filters
        filterTitle: 'ตัวกรอง',
        filterReset: 'รีเซ็ต',
        searchPlaceholder: 'ค้นหาสินค้า...',
        allGames: 'เกมทั้งหมด',
        category: 'หมวดหมู่',
        categoryAll: 'ทั้งหมด',
        categoryAccount: 'ไอดีเกม / บัญชี',
        categoryItem: 'ไอเทม & สกิน',
        priceRange: 'ช่วงราคา (฿)',
        priceMin: 'ต่ำสุด',
        priceMax: 'สูงสุด',
        showing: 'แสดง',
        items: 'รายการ',
        sortNewest: 'ล่าสุด',
        sortPriceLow: 'ราคาต่ำ-สูง',
        sortPriceHigh: 'ราคาสูง-ต่ำ',
        noProducts: 'ยังไม่มีสินค้า',
        noProductsDesc: 'ไม่พบสินค้าที่ตรงกับเงื่อนไข',
        clearFilters: 'ล้างตัวกรองทั้งหมด',
        viewDetail: 'ดูรายละเอียด',
        heroTitle: 'ตลาดซื้อขาย',
        heroDesc: 'ซื้อ-ขายไอดีเกม ไอเทม และบริการต่างๆ จากเกมยอดนิยม พร้อมการรับรองจากทีมงาน Fastlane Lv.',
    },

    // ─── Portfolio ───
    portfolioPage: {
        title: 'ผลงานของเรา',
        subtitle: 'ดูผลงานที่ผ่านมา',
        badge: 'ผลงานของเรา',
        heroDesc: 'รวบรวมผลงานทั้งหมดที่เราภาคภูมิใจ ทั้งรูปภาพและวิดีโอจากการให้บริการลูกค้ากว่าหลายร้อยรายการ',
        photoAlbums: 'อัลบั้มรูปภาพ',
        totalPhotos: 'รูปภาพทั้งหมด',
        videoAlbums: 'อัลบั้มวิดีโอ',
        totalVideos: 'วิดีโอทั้งหมด',
        photosTab: 'รูปภาพผลงาน',
        videosTab: 'วิดีโอผลงาน',
        noPhotoAlbums: 'ยังไม่มีอัลบั้มผลงานรูปภาพ',
        noVideoAlbums: 'ยังไม่มีอัลบั้มวิดีโอผลงาน',
        photos: 'รูป',
        videos: 'วิดีโอ',
        clickViewPhotos: 'คลิกเพื่อดูรูปภาพทั้งหมด',
        clickViewVideos: 'คลิกเพื่อดูวิดีโอทั้งหมด',
        showing: 'แสดง',
        of: 'จาก',
        albums: 'อัลบั้ม',
    },

    // ─── News ───
    newsPage: {
        title: 'ข่าวสาร',
        subtitle: 'อัพเดตข่าวสารล่าสุด',
        readMore: 'อ่านเพิ่มเติม',
        badge: 'ข่าวสาร',
        heroTitle: 'ข่าวสารและอัปเดต',
        heroDesc: 'ติดตามข่าวสารล่าสุดจาก Fastlane Lv.',
        noNews: 'ยังไม่มีข่าวสารในขณะนี้',
        readMoreArrow: 'อ่านเพิ่มเติม →',
        page: 'หน้า',
        close: 'ปิด',
    },

    // ─── Live ───
    livePage: {
        title: 'ไลฟ์สด',
        subtitle: 'ดูไลฟ์สดจากทีมงาน',
        live: 'สด',
        offline: 'ออฟไลน์',
    },

    // ─── Order History ───
    orderHistory: {
        title: 'ประวัติการสั่งซื้อ',
        orderNumber: 'หมายเลขออเดอร์',
        date: 'วันที่',
        status: 'สถานะ',
        total: 'รวม',
        pending: 'รอดำเนินการ',
        processing: 'กำลังดำเนินการ',
        completed: 'สำเร็จ',
        confirmed: 'ยืนยันแล้ว',
        cancelled: 'ยกเลิก',
        noOrders: 'ยังไม่มีประวัติการสั่งซื้อ',
    },

    // ─── Jobboard ───
    jobsPage: {
        title: 'จ้างงาน',
        heroDesc: 'โพสต์งานที่อยากจ้าง แล้วให้แอดมินของร้านกดรับงาน เลือกได้ทั้งขอใบเสนอราคาหรือจ้างตามงบที่ตั้งไว้',
        postJob: '+ ลงประกาศงาน',
        myJobs: 'งานของฉัน',
        tabOpen: 'เปิดรับ',
        tabActive: 'รับงานแล้ว / กำลังทำ',
        tabCompleted: 'เสร็จแล้ว',
        statOpen: 'เปิดรับ',
        statTaken: 'รับงานแล้ว',
        statInProgress: 'กำลังทำ',
        statCompleted: 'เสร็จแล้วทั้งหมด',
        jobsUnit: 'งาน',
        filterAllGames: 'ทุกเกม',
        filterAllServices: 'ทุกหมวดหมู่',
        filterAllJobTypes: 'ทุกประเภทงาน',
        clearFilter: 'ล้างตัวกรอง',
        colJob: 'งาน',
        colCategory: 'หมวดหมู่',
        colHireType: 'ลักษณะการจ้าง',
        colBudget: 'งบประมาณ',
        colWhen: 'เมื่อ',
        colDeliverBy: 'ส่งมอบงานภายใน',
        colStatus: 'สถานะ',
        loadMore: 'โหลดเพิ่ม',
        empty: 'ยังไม่มีงานในแท็บนี้',
        emptyDesc: 'ลองเปลี่ยนแท็บหรือล้างตัวกรอง',
        loadError: 'โหลดหน้าจ้างงานไม่สำเร็จ',
        retry: 'ลองใหม่',
        comingSoon: 'จ้างงาน เร็วๆ นี้',
        comingSoonDesc: 'เร็วๆ นี้ คุณจะโพสต์งานที่อยากจ้างได้เอง และให้แอดมินของร้านกดรับงานได้ทันที',
        staffMode: 'โหมดทดสอบ: หน้านี้เห็นเฉพาะทีมงาน งานที่โพสต์ตอนนี้เป็นงานทดสอบ',
        offMode: 'หน้าจ้างงานปิดอยู่: ลูกค้ายังไม่เห็นหน้านี้ (เห็นเฉพาะทีมงาน)',
        accept: '🙋 รับงาน',
        viewDetail: 'ดูรายละเอียด',
        noDeadline: 'ไม่ระบุ',
        safetyNote: 'โอนเงินเข้าบัญชีร้าน FASTLANE เท่านั้น และส่งข้อมูลบัญชีเกมในแชทออเดอร์เท่านั้น',
        // Detail page
        back: 'กลับไปหน้าจ้างงาน',
        closedTitle: 'งานนี้ปิดรับแล้ว',
        closedDesc: 'ประกาศนี้ถูกปิด ยกเลิก หรือหมดอายุแล้ว ลองดูงานอื่นในหน้าจ้างงาน',
        timeline: 'ความคืบหน้า',
        stepPosted: 'โพสต์งาน',
        stepTaken: 'รับงาน',
        stepTakenBy: 'แอดมิน {name} รับงาน',
        stepTakenTeam: 'ทีมงาน Fastlane รับงาน',
        stepStarted: 'เริ่มดำเนินการ',
        stepCompleted: 'เสร็จสิ้น',
        idleNote: 'งานนี้รอดำเนินการ ยังไม่มีความเคลื่อนไหวล่าสุด',
        details: 'รายละเอียดงาน',
        descClosed: 'รายละเอียดงานแสดงเฉพาะตอนที่งานยังเปิดรับ',
        game: 'เกม',
        category: 'หมวดหมู่',
        hireType: 'ลักษณะการจ้าง',
        playMode: 'รูปแบบ',
        rank: 'แรงค์',
        server: 'เซิร์ฟเวอร์',
        preferredTime: 'เวลาที่สะดวก',
        budget: 'งบประมาณ',
        deliverBy: 'ส่งมอบงานภายใน',
        poster: 'ผู้ว่าจ้าง',
        reopened: '♻️ กลับมาเปิดรับอีกครั้ง',
        // My jobs
        myTitle: 'งานของฉัน',
        myDesc: 'ติดตามสถานะการตรวจโพสต์ แก้ไขโพสต์ที่ไม่ผ่าน ยกเลิกงาน หรือไปที่แชทกับแอดมินที่รับงาน',
        myEmpty: 'คุณยังไม่ได้ลงประกาศงาน',
        backToBoard: 'ไปที่หน้าจ้างงาน',
        cancelJob: 'ยกเลิกงาน',
        goChat: '💬 ไปที่แชท',
        pay: '💳 ชำระเงิน / แนบสลิป',
        repost: 'ลงประกาศซ้ำ',
        viewPublic: 'ดูหน้าประกาศ',
        confirmNotPaid: 'ฉันยังไม่ได้โอนเงินสำหรับงานนี้',
        refresh: 'รีเฟรช',
        // Moderation (pending / rejected posts)
        filterOtherGames: 'เกมอื่นๆ (ลูกค้าระบุเอง)',
        editPostTitle: 'แก้ไขโพสต์งาน',
        reviewNotice: 'ทุกโพสต์ต้องผ่านการตรวจจากแอดมินก่อน จึงจะแสดงในหน้าจ้างงาน',
        statusPending: '⏳ รอแอดมินตรวจสอบ',
        statusRejected: '❌ ไม่ผ่านการอนุมัติ',
        pendingNote: 'โพสต์อยู่ระหว่างรอแอดมินตรวจสอบ จะแสดงในหน้าจ้างงานหลังได้รับการอนุมัติ · ระหว่างนี้แก้ไขโพสต์ไม่ได้ (แก้ได้เมื่อโพสต์ไม่ผ่านการอนุมัติ)',
        submittedAt: 'ส่งตรวจเมื่อ',
        resubmitCount: 'ส่งใหม่แล้ว {n} ครั้ง',
        rejectReasonTitle: 'เหตุผลที่ไม่ผ่านการอนุมัติ',
        rejectedHint: 'แตะเพื่อแก้ไขโพสต์และส่งให้แอดมินตรวจอีกครั้ง',
        rejectedDeadline: 'แก้ไขและส่งใหม่ภายใน {date} มิฉะนั้นโพสต์จะปิดอัตโนมัติ',
        reviewedBy: 'ตรวจโดย',
        editPost: 'แก้ไขโพสต์',
        editResubmit: 'แก้ไขและส่งใหม่',
        cancelPost: 'ยกเลิกโพสต์',
        moderationHistory: 'ประวัติการตรวจโพสต์',
        modSubmit: 'ส่งโพสต์',
        modResubmit: 'แก้ไขและส่งใหม่',
        modApprove: 'อนุมัติ',
        modReject: 'ไม่อนุมัติ',
    },

    // ─── Partner shops (ร้านค้าพันธมิตร — PartnerBand + /partners) ───
    partners: {
        title: 'ร้านค้าพันธมิตร',
        subtitle: 'ร้านค้าที่ร่วมธุรกิจกับ FASTLANE LV',
        viewAll: 'ดูร้านค้าทั้งหมด',
        visit: 'เยี่ยมชมร้าน',
        empty: 'ยังไม่มีร้านค้าพันธมิตรในตอนนี้',
        pageTitle: 'ร้านค้าพันธมิตร - Fastlane Lv.',
        backHome: 'กลับหน้าแรก',
        imageAlt: 'ร้านค้าพันธมิตร',
        prev: 'เลื่อนไปทางซ้าย',
        next: 'เลื่อนไปทางขวา',
    },

    // ─── Common ───
    common: {
        loading: 'กำลังโหลด...',
        save: 'บันทึก',
        cancel: 'ยกเลิก',
        delete: 'ลบ',
        edit: 'แก้ไข',
        confirm: 'ยืนยัน',
        close: 'ปิด',
        back: 'กลับ',
        next: 'ถัดไป',
        previous: 'ก่อนหน้า',
        search: 'ค้นหา',
        noData: 'ไม่มีข้อมูล',
    },
};

export default th;
